import i18next from "i18next";
import HttpApi from "i18next-http-backend";

const i18nextOptions = {
  lng: window.LOCALE,
  debug: false,
  backend: {
    loadPath: '/locales.json',
  },
};

i18next.use(HttpApi).init(i18nextOptions);

document.addEventListener("turbo:render", () => {
  i18next.changeLanguage(window.LOCALE)
})

export default i18next
